import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1fd9bad3&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fd9bad3')) {
      api.createRecord('1fd9bad3', component.options)
    } else {
      api.reload('1fd9bad3', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=1fd9bad3&", function () {
      api.rerender('1fd9bad3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/saas/App.vue"
export default component.exports